import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from "../../environments/environment";
import { EmitterService } from '../services/emitter.service';
import { HostedCashierPaymentsService } from '../services/hosted-cashier-payments.service';
import { UserDetailsService } from '../services/user-details.service';
import { Utility } from '../shared/utility/utility';
import { TranslateService } from "@ngx-translate/core";
import * as _ from 'underscore';
import { combineLatest, Subject } from 'rxjs';
import { AjaxService } from '../services/ajax.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { takeUntil } from "rxjs/operators";
import { Router } from '@angular/router';
@Component({
  selector: 'app-pending-withdrawal-modal',
  templateUrl: './app-pending-withdrawal-modal.component.html',
  styleUrls: ['./app-pending-withdrawal-modal.component.scss']
})
export class AppPendingWithdrawalModalComponent implements OnInit, AfterViewInit, OnDestroy {
  piqObject = {};
  isPendingWithDrawsAvailable = false;
  pendingWithdrawals = [];
  currencyCode: string;
  currencySymbol:string;
  selectedWithdrawCancelTransaction;
  withdrawStatus: string;
  cancelledPendingWithdrawAmount:any=false;
  tokenData;
  isCountryAllowed: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  langCode = "";
  showWithdrawSuccessMsg = false;
  constructor(
    public utils: Utility,
    private emitterService: EmitterService,
    private userDetailsService: UserDetailsService,
    private paymentService:HostedCashierPaymentsService,
    private translationService: TranslateService,
    private ajaxService: AjaxService,
    private pnpService: PnpZimplerService,
    private router: Router,
  ) {
    this.emitterService.withdrwalSuccessMsg$.pipe(takeUntil(this.destroy$)).subscribe(flag => {
      if(flag){
        this.showWithdrawSuccessMsg =true;
        setTimeout(() => {
          this.showWithdrawSuccessMsg = false;
        }, 8000)
      }
    });
   }

  ngOnInit() {

    this.currencyCode = this.userDetailsService.getUserCurrencyCode();
    this.currencySymbol=this.userDetailsService.getUserCurrencySymbol();
    const profileDetails = this.userDetailsService.getUserProfileDetails();
    this.isCountryAllowed = this.emitterService.isCountryAllowed;
    if(!this.userDetailsService.checkIsPNPUser()){
        if (!_.isEmpty(profileDetails)) {
          this.piqObject['userId'] = profileDetails.playerID;
          this.getCashierToken();
        } else {
          const getTokenObservable = this.paymentService.getTokenPaymentIQ('cashier');
          const getProfileDataObservable = this.ajaxService.getProfileBalanceCurrency();
          combineLatest([getTokenObservable,getProfileDataObservable]).pipe(takeUntil(this.destroy$)).subscribe(([tokenData, profileData]:any)=>{
            if (profileData && profileData.profile && profileData.profile.externalEcrId) {
              this.piqObject['userId'] = profileData.profile.externalEcrId;
              this.tokenData=tokenData;
              this.parseTokenData(tokenData);
            }
          });
        }
      } else if(this.isCountryAllowed===1 || this.userDetailsService.checkIsPNPUser()){
          this.zimplerPendingWithdrawls()
      }
      this.loadLanguageCode();
  }

  zimplerPendingWithdrawls(){
    let pendingWithdrawalObject = {
      cashoutVerifiedtxnRequired: true
    }
    this.pnpService.getPendingCashOuts(pendingWithdrawalObject).then(data=>{
      if(data && data.length > 0) {
        this.pendingWithdrawals = data;
        this.isPendingWithDrawsAvailable = true;
        this.emitterService.broadPendingWithdrawlCount(true);
      } else  {
        this.closeModalAndRedirect();
        this.pendingWithdrawals = [];
        this.isPendingWithDrawsAvailable = true;
        this.emitterService.broadPendingWithdrawlCount(true);
      }
    })
    this.withdrawStatus = this.translationService.instant('cashier.processing');
  }

  getCashierToken() {
    this.isPendingWithDrawsAvailable = false;
    this.paymentService.getTokenPaymentIQ('cashier').pipe(takeUntil(this.destroy$)).subscribe((tokenDetails:any) => {

      if (tokenDetails && tokenDetails.status === 'SUCCESS' && tokenDetails.token && tokenDetails.token !== '') {
        this.tokenData=tokenDetails;
        this.parseTokenData(tokenDetails);
        this.piqObject['sessionId'] = tokenDetails.token;
      }
    },
    usedAccountError => {
      console.log(usedAccountError);
    });
    
    
  }

  parseTokenData(tokenDetails) {
    if (tokenDetails.status === 'SUCCESS' && tokenDetails.token && tokenDetails.token !== '') {

      this.piqObject['sessionId'] = tokenDetails.token;
      this.piqObject['merchantId'] = environment.paymentIqMID;
      this.getPendingWithdrawals();
    } else {
      this.pendingWithdrawals = [];
      this.isPendingWithDrawsAvailable = false;
    }
  }

  getPendingWithdrawals() {
    const getPendingWithdrawalObject = _.clone(this.piqObject);
    getPendingWithdrawalObject['method'] = 'Withdrawal';
    getPendingWithdrawalObject['states'] = 'WAITING_APPROVAL';
    this.paymentService.getPendingWithdrawal(getPendingWithdrawalObject).pipe(takeUntil(this.destroy$)).subscribe(pendingWithdrawalData => {
        if (pendingWithdrawalData && pendingWithdrawalData.success && pendingWithdrawalData.transactions) {
          this.pendingWithdrawals = pendingWithdrawalData.transactions;
          if(!this.pendingWithdrawals || this.pendingWithdrawals.length == 0){
             this.closeModalAndRedirect();
          }
          this.isPendingWithDrawsAvailable = true;
          this.emitterService.broadPendingWithdrawlCount(true);
        } 
      },
      rejectError => {
        this.pendingWithdrawals = [];
        this.isPendingWithDrawsAvailable = false;
        this.emitterService.broadPendingWithdrawlCount(true);
      }
    );
    this.withdrawStatus = this.translationService.instant('cashier.processing');
  }

  ngAfterViewInit() {
    this.utils.openModal('pendingwithdrawal');
  }

  closeModalAndRedirect(){
    let self = this;
    setTimeout(()=>{
     self.router.navigate([this.langCode + '/casino/allgames']);
     self.close();
    },3000)
  }
  close(){
    this.emitterService.broadcastModalState({name:"pendingwithdrawl",state:"close"});
  }

  /*Function checks if source is backoffice or PaymentIQ and sends for the respective call*/ 
  deleteWithdrawal(txnId,amount,buttonId){
    
    this.utils.disableNewButton(buttonId);
    const cancelWithdrawObject = _.clone(this.piqObject);
    cancelWithdrawObject['transactionId'] = txnId;
    this.paymentService.cancelTransaction(cancelWithdrawObject).pipe(takeUntil(this.destroy$)).subscribe(cancelWithdraw => {
        if (cancelWithdraw && cancelWithdraw.success) {
          this.emitterService.broadcasttxnComplete("SUCCESS");
          this.cancelledPendingWithdrawAmount = this.amountCurrencyFormat(amount);
          this.showWithdrawSuccessMsg = false;
          if(this.pendingWithdrawals && this.pendingWithdrawals.length == 1){
            setTimeout(()=>{ this.cancelledPendingWithdrawAmount = false; },4000)            
          }else{  
            this.timeOut=setTimeout(()=>{ this.cancelledPendingWithdrawAmount = false;},3000)
          }
          this.getPendingWithdrawals();
        } else {
          console.log('Unable to cancel Withdraw');
        }
      },
      rejectError => {
        console.log('Unable to cancel Withdraw');
      }
    );
  }
  timeOut:any = "";
  deleteZimplerPendingAmount(txnId,amount,buttonId){
    clearTimeout(this.timeOut)
    this.utils.disableNewButton(buttonId);
    let cancelWithdrawObject = {
      txnId: txnId,
      txnAmount: amount
    }
    this.ajaxService.canclePendingWithdrawls(cancelWithdrawObject).then(
      (cancelWithdraw:any) => {
        if (cancelWithdraw && cancelWithdraw.status) {
          this.emitterService.broadcasttxnComplete("SUCCESS");
          this.cancelledPendingWithdrawAmount = this.userDetailsService.getUserFormatedBalence(amount);
          if(this.pendingWithdrawals && this.pendingWithdrawals.length == 1){
            setTimeout(()=>{ this.cancelledPendingWithdrawAmount = false; },4000)            
          }else{  
            this.timeOut=setTimeout(()=>{ this.cancelledPendingWithdrawAmount = false;},3000)
          }
          this.zimplerPendingWithdrawls();
         
        } else {
          console.log('Unable to cancel Withdraw');
        }
      },
      rejectError => {
        console.log('Unable to cancel Withdraw');
      }
    );
  }

  amountCurrencyFormat(value){
    if(value && this.currencyCode){
      var regex = new RegExp("-|"+this.currencyCode+"| ",'gi');
      return this.currencySymbol+""+value.replace(regex,'');
    }else{
      return value;
    }
  }
  loadLanguageCode(){
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    })
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
